// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/img/sidebar-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.0 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  /* 3 */
  tab-size: 4;
  /* 3 */
  font-family: "IBM Plex Sans", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.visible {
  visibility: visible;
}

.collapse {
  visibility: collapse;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-0 {
  inset: 0px;
}

.inset-x-0 {
  left: 0px;
  right: 0px;
}

.-bottom-20 {
  bottom: -5rem;
}

.-left-5 {
  left: -1.25rem;
}

.-right-5 {
  right: -1.25rem;
}

.bottom-0 {
  bottom: 0px;
}

.bottom-full {
  bottom: 100%;
}

.left-1\\/2 {
  left: 50%;
}

.start-0 {
  inset-inline-start: 0px;
}

.top-0 {
  top: 0px;
}

.top-1\\/2 {
  top: 50%;
}

.top-full {
  top: 100%;
}

.-z-10 {
  z-index: -10;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-50 {
  z-index: 50;
}

.z-\\[1\\] {
  z-index: 1;
}

.z-\\[60\\] {
  z-index: 60;
}

.col-span-1 {
  grid-column: span 1 / span 1;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.m-3 {
  margin: 0.75rem;
}

.m-px {
  margin: 1px;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-1\\.5 {
  margin-bottom: 0.375rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mt-0 {
  margin-top: 0px;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mt-\\[180px\\] {
  margin-top: 180px;
}


.mt-2 {
  margin-top: 0.5rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.contents {
  display: contents;
}

.hidden {
  display: none;
}

.h-1 {
  height: 0.25rem;
}

.h-1\\.5 {
  height: 0.375rem;
}

.h-10 {
  height: 2.5rem;
}

.h-12 {
  height: 3rem;
}

.h-2 {
  height: 0.5rem;
}

.h-20 {
  height: 5rem;
}

.h-3 {
  height: 0.75rem;
}

.h-3\\.5 {
  height: 0.875rem;
}

.h-4 {
  height: 1rem;
}

.h-48 {
  height: 12rem;
}

.h-5 {
  height: 1.25rem;
}

.h-6 {
  height: 1.5rem;
}

.h-7 {
  height: 1.75rem;
}

.h-8 {
  height: 2rem;
}

.h-9 {
  height: 2.25rem;
}

.h-\\[200px\\] {
  height: 200px;
}

.h-\\[3px\\] {
  height: 3px;
}

.h-full {
  height: 100%;
}

.max-h-\\[300px\\] {
  max-height: 300px;
}

.max-h-\\[340px\\] {
  max-height: 340px;
}

.max-h-\\[380px\\] {
  max-height: 380px;
}

.max-h-\\[450px\\] {
  max-height: 450px;
}

.max-h-\\[600px\\] {
  max-height: 600px;
}

.h-\\[600px\\] {
  height: 600px;
}

.min-h-\\[200px\\] {
  min-height: 200px;
}

.min-h-\\[360px\\] {
  min-height: 360px;
}

.w-12 {
  width: 3rem;
}

.w-2 {
  width: 0.5rem;
}

.w-20 {
  width: 5rem;
}

.w-3 {
  width: 0.75rem;
}

.w-3\\.5 {
  width: 0.875rem;
}

.w-32 {
  width: 8rem;
}

.w-4 {
  width: 1rem;
}

.w-48 {
  width: 12rem;
}

.w-5 {
  width: 1.25rem;
}

.w-6 {
  width: 1.5rem;
}

.w-64 {
  width: 16rem;
}

.w-7 {
  width: 1.75rem;
}

.w-8 {
  width: 2rem;
}

.w-9 {
  width: 2.25rem;
}

.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}

.w-full {
  width: 100%;
}

.min-w-40 {
  min-width: 10rem;
}

.max-w-sm {
  max-width: 24rem;
}

.flex-1 {
  flex: 1 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.origin-top-left {
  transform-origin: top left;
}

.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes confetti-1 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(-400%,-200%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(-400%,-200%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(-400%,-200%,0) scale(0.5) rotate(180deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-1 {
  animation: confetti-1 2s ease-in-out infinite;
}

@keyframes confetti-2 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(300%,150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(300%,150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(300%,150%,0) scale(0.5) rotate(180deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-2 {
  animation: confetti-2 2s ease-in-out 0.1s infinite;
}

@keyframes confetti-3 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(150%,-200%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(150%,-200%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(150%,-200%,0) scale(0.5) rotate(180deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-3 {
  animation: confetti-3 2s ease-in-out infinite;
}

@keyframes confetti-4 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(-320%,150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(-320%,150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(-320%,150%,0) scale(0.5) rotate(180deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-4 {
  animation: confetti-4 2s ease-in-out 0.1s infinite;
}

@keyframes confetti-5 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(-100%,-150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(-100%,-150%,0) scale(1) rotate(360deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(-100%,-150%,0) scale(0.5) rotate(90deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-5 {
  animation: confetti-5 2s ease-in-out 0.1s infinite;
}

@keyframes confetti-6 {
  0% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 1;
  }

  50% {
    transform: translate3d(-100%,200%,0) scale(1) rotate(180deg);
    opacity: 1;
  }

  75% {
    transform: translate3d(-100%,200%,0) scale(1) rotate(180deg);
    opacity: 1;
  }

  90% {
    transform: translate3d(-100%,200%,0) scale(0.5) rotate(90deg);
    opacity: 0;
  }

  100% {
    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);
    opacity: 0;
  }
}

.animate-confetti-6 {
  animation: confetti-6 2s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.cursor-move {
  cursor: move;
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
          user-select: none;
}

.resize {
  resize: both;
}


.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.place-content-center {
  place-content: center;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-3\\.5 {
  gap: 0.875rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-px {
  gap: 1px;
}

.gap-x-1 {
  column-gap: 0.25rem;
}

.gap-x-10 {
  column-gap: 2.5rem;
}

.gap-x-2 {
  column-gap: 0.5rem;
}

.gap-x-3 {
  column-gap: 0.75rem;
}

.gap-y-2 {
  row-gap: 0.5rem;
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}

.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.whitespace-preline {
  white-space: pre-line;
}

.text-nowrap {
  text-wrap: nowrap;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}

.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}

.border-accent-2 {
  --tw-border-opacity: 1;
  border-color: rgb(15 15 116 / var(--tw-border-opacity));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.border-secondary\\/20 {
  border-color: rgb(74 162 233 / 0.2);
}

.border-transparent {
  border-color: transparent;
}

.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}

.border-b-secondary\\/20 {
  border-bottom-color: rgb(74 162 233 / 0.2);
}

.border-t-transparent {
  border-top-color: transparent;
}

.bg-\\[\\#E7F2FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 242 250 / var(--tw-bg-opacity));
}

.bg-\\[\\#f4b610\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 182 16 / var(--tw-bg-opacity));
}

.bg-accent-1 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 191 255 / var(--tw-bg-opacity));
}

.bg-accent-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 116 / var(--tw-bg-opacity));
}

.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}

.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 58 / var(--tw-bg-opacity));
}

.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(74 162 233 / var(--tw-bg-opacity));
}

.bg-secondary\\/10 {
  background-color: rgb(74 162 233 / 0.1);
}

.bg-secondary\\/15 {
  background-color: rgb(74 162 233 / 0.15);
}

.bg-secondary\\/50 {
  background-color: rgb(74 162 233 / 0.5);
}

.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}

.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}

.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}

.bg-\\[url\\(\\'\\/assets\\/img\\/sidebar-bg\\.jpg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.bg-cover {
  background-size: cover;
}

.bg-center {
  background-position: center;
}

.bg-no-repeat {
  background-repeat: no-repeat;
}

.object-cover {
  object-fit: cover;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pb-1\\.5 {
  padding-bottom: 0.375rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pb-16 {
  padding-bottom: 4rem;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-start {
  text-align: start;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-5xl {
  font-size: 3rem;
  line-height: 1;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.leading-none {
  line-height: 1;
}

.text-accent-2 {
  --tw-text-opacity: 1;
  color: rgb(15 15 116 / var(--tw-text-opacity));
}

.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-primary {
  --tw-text-opacity: 1;
  color: rgb(17 17 58 / var(--tw-text-opacity));
}

.text-primary\\/40 {
  color: rgb(17 17 58 / 0.4);
}

.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(74 162 233 / var(--tw-text-opacity));
}

.text-secondary\\/50 {
  color: rgb(74 162 233 / 0.5);
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}

.opacity-0 {
  opacity: 0;
}

.opacity-25 {
  opacity: 0.25;
}

.opacity-75 {
  opacity: 0.75;
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.delay-100 {
  transition-delay: 100ms;
}

.duration-100 {
  transition-duration: 100ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.slider-navs .tns-nav-active {
  --tw-bg-opacity: 1;
  background-color: rgb(74 162 233 / var(--tw-bg-opacity));
}

.moveable-control-box {
  display: none !important;
}

/* Tab */

.tab .active {
  --tw-border-opacity: 1;
  border-color: rgb(15 15 116 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 116 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tab-content {
  display: none;
}

.tab-content.active {
  display: block;
}

.tab.reorder {
  flex-direction: row;
}

.placeholder\\:text-transparent::placeholder {
  color: transparent;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}

.before\\:-bottom-\\[11px\\]::before {
  content: var(--tw-content);
  bottom: -11px;
}

.before\\:-bottom-\\[13px\\]::before {
  content: var(--tw-content);
  bottom: -13px;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:z-\\[1\\]::before {
  content: var(--tw-content);
  z-index: 1;
}

.before\\:h-\\[3px\\]::before {
  content: var(--tw-content);
  height: 3px;
}

.before\\:w-\\[calc\\(100\\%\\+\\.5rem\\)\\]::before {
  content: var(--tw-content);
  width: calc(100% + .5rem);
}

.before\\:bg-secondary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(74 162 233 / var(--tw-bg-opacity));
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}

.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}

.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.autofill\\:pb-2:autofill {
  padding-bottom: 0.5rem;
}

.autofill\\:pt-6:autofill {
  padding-top: 1.5rem;
}

.hover\\:border-\\[\\#5BE7CD\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(91 231 205 / var(--tw-border-opacity));
}

.hover\\:border-\\[\\#F55F6E\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 95 110 / var(--tw-border-opacity));
}

.hover\\:border-\\[\\#f4b610\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(244 182 16 / var(--tw-border-opacity));
}

.hover\\:border-accent-2:hover {
  --tw-border-opacity: 1;
  border-color: rgb(15 15 116 / var(--tw-border-opacity));
}

.hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 17 58 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#5BE7CD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(91 231 205 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#F55F6E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 95 110 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#f4b610\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 182 16 / var(--tw-bg-opacity));
}

.hover\\:bg-accent-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 116 / var(--tw-bg-opacity));
}

.hover\\:bg-accent-2\\/10:hover {
  background-color: rgb(15 15 116 / 0.1);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 58 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(74 162 233 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary\\/20:hover {
  background-color: rgb(74 162 233 / 0.2);
}

.hover\\:bg-secondary\\/30:hover {
  background-color: rgb(74 162 233 / 0.3);
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(17 17 58 / var(--tw-text-opacity));
}

.hover\\:text-secondary:hover {
  --tw-text-opacity: 1;
  color: rgb(74 162 233 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:border-x-transparent:focus {
  border-left-color: transparent;
  border-right-color: transparent;
}

.focus\\:border-b-secondary:focus {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(74 162 233 / var(--tw-border-opacity));
}

.focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}

.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.focus\\:pb-2:focus {
  padding-bottom: 0.5rem;
}

.focus\\:pt-6:focus {
  padding-top: 1.5rem;
}

.focus\\:text-gray-600:focus {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.focus\\:text-secondary:focus {
  --tw-text-opacity: 1;
  color: rgb(74 162 233 / var(--tw-text-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-accent-2\\/20:focus {
  --tw-ring-color: rgb(15 15 116 / 0.2);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.focus\\:ring-primary\\/20:focus {
  --tw-ring-color: rgb(17 17 58 / 0.2);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:text-gray-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group:hover .group-hover\\:ring-secondary\\/20 {
  --tw-ring-color: rgb(74 162 233 / 0.2);
}

.peer:focus ~ .peer-focus\\:-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.peer:disabled ~ .peer-disabled\\:pointer-events-none {
  pointer-events: none;
}

.peer:disabled ~ .peer-disabled\\:opacity-50 {
  opacity: 0.5;
}

.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

[data-hs-tab].active.hs-tab-active\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(74 162 233 / var(--tw-border-opacity));
}

[data-hs-tab].active.hs-tab-active\\:text-secondary {
  --tw-text-opacity: 1;
  color: rgb(74 162 233 / var(--tw-text-opacity));
}

[data-hs-tab].active .hs-tab-active\\:border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(74 162 233 / var(--tw-border-opacity));
}

[data-hs-tab].active .hs-tab-active\\:text-secondary {
  --tw-text-opacity: 1;
  color: rgb(74 162 233 / var(--tw-text-opacity));
}

.open.hs-overlay-open\\:mt-7 {
  margin-top: 1.75rem;
}

.open.hs-overlay-open\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.open.hs-overlay-open\\:opacity-100 {
  opacity: 1;
}

.open.hs-overlay-open\\:duration-500 {
  transition-duration: 500ms;
}

.open .hs-overlay-open\\:mt-7 {
  margin-top: 1.75rem;
}

.open .hs-overlay-open\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.open .hs-overlay-open\\:opacity-100 {
  opacity: 1;
}

.open .hs-overlay-open\\:duration-500 {
  transition-duration: 500ms;
}

.selected.hs-selected\\:block {
  display: block;
}

.selected .hs-selected\\:block {
  display: block;
}

.disabled.hs-select-disabled\\:pointer-events-none {
  pointer-events: none;
}

.disabled.hs-select-disabled\\:opacity-50 {
  opacity: 0.5;
}

.disabled .hs-select-disabled\\:pointer-events-none {
  pointer-events: none;
}

.disabled .hs-select-disabled\\:opacity-50 {
  opacity: 0.5;
}

@media (min-width: 640px) {
  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }
}

@media (min-width: 768px) {
  .md\\:-bottom-16 {
    bottom: -4rem;
  }

  .md\\:h-\\[200px\\] {
    height: 200px;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:left-auto {
    left: auto;
  }

  .lg\\:mt-8 {
    margin-top: 2rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-10 {
    height: 2.5rem;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:w-72 {
    width: 18rem;
  }

  .lg\\:w-96 {
    width: 24rem;
  }

  .lg\\:w-\\[calc\\(100\\%-290px\\)\\] {
    width: calc(100% - 290px);
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:rounded-s-\\[3rem\\] {
    border-start-start-radius: 3rem;
    border-end-start-radius: 3rem;
  }

  .lg\\:rounded-tr-none {
    border-top-right-radius: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-12 {
    padding: 3rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-4 {
    padding-bottom: 1rem;
  }

  .conv-lab-bottom-bar {
    position: absolute;
    width: calc(100% - 3rem);
    bottom: 0.5rem;
    left: 2rem;
  }
}

@media (min-width: 1280px) {
  .xl\\:-left-10 {
    left: -2.5rem;
  }

  .xl\\:-right-10 {
    right: -2.5rem;
  }

  .xl\\:mt-20 {
    margin-top: 5rem;
  }

  .xl\\:h-12 {
    height: 3rem;
  }

  .xl\\:h-7 {
    height: 1.75rem;
  }

  .xl\\:w-12 {
    width: 3rem;
  }

  .xl\\:w-56 {
    width: 14rem;
  }

  .xl\\:w-7 {
    width: 1.75rem;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:gap-10 {
    gap: 2.5rem;
  }

  .xl\\:gap-20 {
    gap: 5rem;
  }
}

@media (min-width: 1536px) {
  .\\32xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .\\32xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:gap-20 {
    gap: 5rem;
  }

  .\\32xl\\:p-10 {
    padding: 2.5rem;
  }

  .\\32xl\\:p-16 {
    padding: 4rem;
  }

  .\\32xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .conv-lab-bottom-bar {
    position: absolute;
    width: calc(100% - 7rem);
    bottom: 0.5rem;
    left: 3.5rem;
  }
}

:is(:where(.dark) .dark\\:border-gray-700) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}

:is(:where(.dark) .dark\\:bg-blue-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:bg-slate-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:bg-opacity-80) {
  --tw-bg-opacity: 0.8;
}

:is(:where(.dark) .dark\\:text-gray-200) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:text-gray-400) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:hover\\:border-gray-700:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}

:is(:where(.dark) .dark\\:hover\\:bg-gray-700:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:focus\\:outline-none:focus) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

:is(:where(.dark) .dark\\:focus\\:ring-1:focus) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

:is(:where(.dark) .dark\\:focus\\:ring-gray-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-secondary\\/80::-webkit-scrollbar-thumb {
  background-color: rgb(74 162 233 / 0.8);
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-secondary\\/20::-webkit-scrollbar-track {
  background-color: rgb(74 162 233 / 0.2);
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}

.\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pb-2:not(:placeholder-shown) {
  padding-bottom: 0.5rem;
}

.\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pt-6:not(:placeholder-shown) {
  padding-top: 1.5rem;
}

@media (min-height: 800px) {
  .h-justify-around {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .h-mt-6 {
    margin-top: 1.5rem;
  }
  .h-mt-10 {
    margin-top: 2.5rem;
  }
  .h-py-8 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .h-gap-3 {
    gap: 0.75rem;
  }
  .h-py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .h-max-h-\\[450px\\] {
    max-height: 450px;
  }
  .h-max-h-\\[480px\\] {
    max-height: 480px;
  }
}

.search-icon {
  cursor: pointer;
  transition: width 2s ease;
}

.move-left {
  right: calc(100% - 20px); /* Moves to left, adjust based on your layout */
}

div#date-pick-div > div > div > :first-child {
  background-color: rgb(230, 239, 246);
}

div#date-pick-div > div > div > :last-child {
  /* background-color: rgb(91 231 205 / var(--tw-border-opacity)); */
  background-color: rgb(230, 239, 246) !important;
}

div#date-pick-div > div > div button:not(.text-gray-400){
  color: black !important;
}

/* div#date-pick-div > div > div button.w-12.h-12 {
  width: 2rem;
  height: 2rem;
} */

div#date-pick-div > div > div button.text-indigo-500{
  border-bottom: 1px solid indigo;
}

div#date-pick-div > div > div button.font-medium{
  border: 1px solid indigo;
}

div.search-component select option {
  background-color: rgb(230, 239, 246);
  text-align: start;
  border-bottom: 1px solid indigo;
}

.playback-scrollbar::-webkit-scrollbar {
  width: 8px; /* Width of the vertical scrollbar */
}
.playback-scrollbar::-webkit-scrollbar-track {
  background: rgba(74, 162, 233, 0.2); /* Track color */
}
.playback-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(74, 162, 233, 0.8); /* Thumb color */
}

/* Horizontal scrollbar */
.playback-scrollbar::-webkit-scrollbar:horizontal {
  height: 8px; /* Height of the horizontal scrollbar */
}

.min-w-min {
  min-width: min-content;
}

.resize-none {
  resize: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;;CAGC;;AAED;;;EAGE,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;CAQC;;AAED;;EAEE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EAEN,MAAM;EAEH,WAAW;EACd,MAAM;EACN,gJAAgJ;EAChJ,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;EACN,wCAAwC;EACxC,MAAM;AACR;;AAEA;;;CAGC;;AAED;EACE,SAAS;EACT,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;EACE,SAAS;EACT,MAAM;EACN,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;EAIE,+GAA+G;EAC/G,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;EACN,yBAAyB;EACzB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB;EACpB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gCAAgC;EAChC,MAAM;EACN,eAAe;EACf,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,cAAc;EACd,MAAM;EACN,SAAS;EACT,MAAM;EACN,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AASD;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;;AAED;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;EAQE,cAAc;EACd,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;;AAExE;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,uBAAuB;EACvB,+LAA+L;AACjM;;AAEA;EACE,sBAAsB;EACtB,+LAA+L;AACjM;;AAEA;EACE,+LAA+L;AACjM;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,+DAA+D;IAC/D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,2DAA2D;IAC3D,UAAU;EACZ;;EAEA;IACE,2DAA2D;IAC3D,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,8DAA8D;IAC9D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,8DAA8D;IAC9D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,8DAA8D;IAC9D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,sDAAsD;IACtD,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,6DAA6D;IAC7D,UAAU;EACZ;;EAEA;IACE,sDAAsD;IACtD,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;UAEjB,iBAAiB;AAC3B;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EAEO,mBAAmB;AAC1B;;AAEA;EAEO,kBAAkB;AACzB;;AAEA;EAEO,kBAAkB;AACzB;;AAEA;EAEO,mBAAmB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,gEAAgE;EAChE,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,gEAAgE;EAChE,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,4DAA4D;EAC5D,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yDAAuD;AACzD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAEK,iBAAiB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,uGAAuG;AACzG;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,oBAAoB;EACpB,iLAAiL;AACnL;;AAEA;EACE,iLAAiL;AACnL;;AAEA;EACE,gKAAgK;EAChK,wJAAwJ;EACxJ,iLAAiL;EACjL,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,QAAQ;;AAER;EACE,sBAAsB;EACtB,uDAAuD;EACvD,kBAAkB;EAClB,uDAAuD;EACvD,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAMA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAMA;EACE,sBAAsB;AACxB;;AAMA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;AACjE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,+LAA+L;AACjM;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+LAA+L;AACjM;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAOA;EACE,0BAA0B;EAC1B,+LAA+L;AACjM;;AAQA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+LAA+L;AACjM;;AAOA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,oDAAoD;IACpD,6DAA6D;EAC/D;;EAEA;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAMA;EACE,sBAAsB;AACxB;;AAMA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB,EAAE,+CAA+C;AAC3E;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kEAAkE;EAClE,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU,EAAE,oCAAoC;AAClD;AACA;EACE,mCAAmC,EAAE,gBAAgB;AACvD;AACA;EACE,mCAAmC,EAAE,gBAAgB;AACvD;;AAEA,yBAAyB;AACzB;EACE,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*\n! tailwindcss v3.4.0 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n7. Disable tap highlights on iOS\n*/\n\nhtml,\n:host {\n  line-height: 1.5;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4;\n  /* 3 */\n  font-family: \"IBM Plex Sans\", ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  /* 4 */\n  font-feature-settings: normal;\n  /* 5 */\n  font-variation-settings: normal;\n  /* 6 */\n  -webkit-tap-highlight-color: transparent;\n  /* 7 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0;\n  /* 1 */\n  line-height: inherit;\n  /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  border-top-width: 1px;\n  /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  /* 1 */\n  font-feature-settings: normal;\n  /* 2 */\n  font-variation-settings: normal;\n  /* 3 */\n  font-size: 1em;\n  /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0;\n  /* 1 */\n  border-color: inherit;\n  /* 2 */\n  border-collapse: collapse;\n  /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-feature-settings: inherit;\n  /* 1 */\n  font-variation-settings: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  font-weight: inherit;\n  /* 1 */\n  line-height: inherit;\n  /* 1 */\n  color: inherit;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n  padding: 0;\n  /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n  /* 1 */\n  background-color: transparent;\n  /* 2 */\n  background-image: none;\n  /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden] {\n  display: none;\n}\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n.container {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1536px;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.pointer-events-auto {\n  pointer-events: auto;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.collapse {\n  visibility: collapse;\n}\n\n.static {\n  position: static;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.inset-0 {\n  inset: 0px;\n}\n\n.inset-x-0 {\n  left: 0px;\n  right: 0px;\n}\n\n.-bottom-20 {\n  bottom: -5rem;\n}\n\n.-left-5 {\n  left: -1.25rem;\n}\n\n.-right-5 {\n  right: -1.25rem;\n}\n\n.bottom-0 {\n  bottom: 0px;\n}\n\n.bottom-full {\n  bottom: 100%;\n}\n\n.left-1\\/2 {\n  left: 50%;\n}\n\n.start-0 {\n  inset-inline-start: 0px;\n}\n\n.top-0 {\n  top: 0px;\n}\n\n.top-1\\/2 {\n  top: 50%;\n}\n\n.top-full {\n  top: 100%;\n}\n\n.-z-10 {\n  z-index: -10;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.z-20 {\n  z-index: 20;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.z-\\[1\\] {\n  z-index: 1;\n}\n\n.z-\\[60\\] {\n  z-index: 60;\n}\n\n.col-span-1 {\n  grid-column: span 1 / span 1;\n}\n\n.col-span-3 {\n  grid-column: span 3 / span 3;\n}\n\n.m-3 {\n  margin: 0.75rem;\n}\n\n.m-px {\n  margin: 1px;\n}\n\n.mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.mx-1\\.5 {\n  margin-left: 0.375rem;\n  margin-right: 0.375rem;\n}\n\n.mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.mb-1\\.5 {\n  margin-bottom: 0.375rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n\n.mt-0 {\n  margin-top: 0px;\n}\n\n.mt-10 {\n  margin-top: 2.5rem;\n}\n\n.mt-12 {\n  margin-top: 3rem;\n}\n\n.mt-\\[180px\\] {\n  margin-top: 180px;\n}\n\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-3 {\n  margin-top: 0.75rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n.block {\n  display: block;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.flex {\n  display: flex;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.table {\n  display: table;\n}\n\n.grid {\n  display: grid;\n}\n\n.contents {\n  display: contents;\n}\n\n.hidden {\n  display: none;\n}\n\n.h-1 {\n  height: 0.25rem;\n}\n\n.h-1\\.5 {\n  height: 0.375rem;\n}\n\n.h-10 {\n  height: 2.5rem;\n}\n\n.h-12 {\n  height: 3rem;\n}\n\n.h-2 {\n  height: 0.5rem;\n}\n\n.h-20 {\n  height: 5rem;\n}\n\n.h-3 {\n  height: 0.75rem;\n}\n\n.h-3\\.5 {\n  height: 0.875rem;\n}\n\n.h-4 {\n  height: 1rem;\n}\n\n.h-48 {\n  height: 12rem;\n}\n\n.h-5 {\n  height: 1.25rem;\n}\n\n.h-6 {\n  height: 1.5rem;\n}\n\n.h-7 {\n  height: 1.75rem;\n}\n\n.h-8 {\n  height: 2rem;\n}\n\n.h-9 {\n  height: 2.25rem;\n}\n\n.h-\\[200px\\] {\n  height: 200px;\n}\n\n.h-\\[3px\\] {\n  height: 3px;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.max-h-\\[300px\\] {\n  max-height: 300px;\n}\n\n.max-h-\\[340px\\] {\n  max-height: 340px;\n}\n\n.max-h-\\[380px\\] {\n  max-height: 380px;\n}\n\n.max-h-\\[450px\\] {\n  max-height: 450px;\n}\n\n.max-h-\\[600px\\] {\n  max-height: 600px;\n}\n\n.h-\\[600px\\] {\n  height: 600px;\n}\n\n.min-h-\\[200px\\] {\n  min-height: 200px;\n}\n\n.min-h-\\[360px\\] {\n  min-height: 360px;\n}\n\n.w-12 {\n  width: 3rem;\n}\n\n.w-2 {\n  width: 0.5rem;\n}\n\n.w-20 {\n  width: 5rem;\n}\n\n.w-3 {\n  width: 0.75rem;\n}\n\n.w-3\\.5 {\n  width: 0.875rem;\n}\n\n.w-32 {\n  width: 8rem;\n}\n\n.w-4 {\n  width: 1rem;\n}\n\n.w-48 {\n  width: 12rem;\n}\n\n.w-5 {\n  width: 1.25rem;\n}\n\n.w-6 {\n  width: 1.5rem;\n}\n\n.w-64 {\n  width: 16rem;\n}\n\n.w-7 {\n  width: 1.75rem;\n}\n\n.w-8 {\n  width: 2rem;\n}\n\n.w-9 {\n  width: 2.25rem;\n}\n\n.w-\\[calc\\(100\\%-2rem\\)\\] {\n  width: calc(100% - 2rem);\n}\n\n.w-full {\n  width: 100%;\n}\n\n.min-w-40 {\n  min-width: 10rem;\n}\n\n.max-w-sm {\n  max-width: 24rem;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.origin-top-left {\n  transform-origin: top left;\n}\n\n.-translate-x-1\\/2 {\n  --tw-translate-x: -50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-x-full {\n  --tw-translate-x: -100%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.-translate-y-1\\/2 {\n  --tw-translate-y: -50%;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n@keyframes confetti-1 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(-400%,-200%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(-400%,-200%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(-400%,-200%,0) scale(0.5) rotate(180deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-1 {\n  animation: confetti-1 2s ease-in-out infinite;\n}\n\n@keyframes confetti-2 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(300%,150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(300%,150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(300%,150%,0) scale(0.5) rotate(180deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-2 {\n  animation: confetti-2 2s ease-in-out 0.1s infinite;\n}\n\n@keyframes confetti-3 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(150%,-200%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(150%,-200%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(150%,-200%,0) scale(0.5) rotate(180deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-3 {\n  animation: confetti-3 2s ease-in-out infinite;\n}\n\n@keyframes confetti-4 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(-320%,150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(-320%,150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(-320%,150%,0) scale(0.5) rotate(180deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-4 {\n  animation: confetti-4 2s ease-in-out 0.1s infinite;\n}\n\n@keyframes confetti-5 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(-100%,-150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(-100%,-150%,0) scale(1) rotate(360deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(-100%,-150%,0) scale(0.5) rotate(90deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-5 {\n  animation: confetti-5 2s ease-in-out 0.1s infinite;\n}\n\n@keyframes confetti-6 {\n  0% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translate3d(-100%,200%,0) scale(1) rotate(180deg);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translate3d(-100%,200%,0) scale(1) rotate(180deg);\n    opacity: 1;\n  }\n\n  90% {\n    transform: translate3d(-100%,200%,0) scale(0.5) rotate(90deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(-50%,-50%,0) scale(0) rotate(0);\n    opacity: 0;\n  }\n}\n\n.animate-confetti-6 {\n  animation: confetti-6 2s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.select-none {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.resize {\n  resize: both;\n}\n\n\n.grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\] {\n  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.place-content-center {\n  place-content: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-10 {\n  gap: 2.5rem;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-3 {\n  gap: 0.75rem;\n}\n\n.gap-3\\.5 {\n  gap: 0.875rem;\n}\n\n.gap-4 {\n  gap: 1rem;\n}\n\n.gap-5 {\n  gap: 1.25rem;\n}\n\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.gap-px {\n  gap: 1px;\n}\n\n.gap-x-1 {\n  -moz-column-gap: 0.25rem;\n       column-gap: 0.25rem;\n}\n\n.gap-x-10 {\n  -moz-column-gap: 2.5rem;\n       column-gap: 2.5rem;\n}\n\n.gap-x-2 {\n  -moz-column-gap: 0.5rem;\n       column-gap: 0.5rem;\n}\n\n.gap-x-3 {\n  -moz-column-gap: 0.75rem;\n       column-gap: 0.75rem;\n}\n\n.gap-y-2 {\n  row-gap: 0.5rem;\n}\n\n.space-x-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(1rem * var(--tw-space-x-reverse));\n  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));\n}\n\n.space-y-0 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0px * var(--tw-space-y-reverse));\n}\n\n.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));\n}\n\n.space-y-1 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));\n}\n\n.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));\n}\n\n.space-y-4 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(1rem * var(--tw-space-y-reverse));\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-y-auto {\n  overflow-y: auto;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.whitespace-preline {\n  white-space: pre-line;\n}\n\n.text-nowrap {\n  text-wrap: nowrap;\n}\n\n.rounded-2xl {\n  border-radius: 1rem;\n}\n\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n\n.rounded-t-2xl {\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-b {\n  border-bottom-width: 1px;\n}\n\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n\n.border-b-\\[2px\\] {\n  border-bottom-width: 2px;\n}\n\n.border-b-\\[3px\\] {\n  border-bottom-width: 3px;\n}\n\n.border-accent-2 {\n  --tw-border-opacity: 1;\n  border-color: rgb(15 15 116 / var(--tw-border-opacity));\n}\n\n.border-gray-200 {\n  --tw-border-opacity: 1;\n  border-color: rgb(229 231 235 / var(--tw-border-opacity));\n}\n\n.border-secondary\\/20 {\n  border-color: rgb(74 162 233 / 0.2);\n}\n\n.border-transparent {\n  border-color: transparent;\n}\n\n.border-x-transparent {\n  border-left-color: transparent;\n  border-right-color: transparent;\n}\n\n.border-b-secondary\\/20 {\n  border-bottom-color: rgb(74 162 233 / 0.2);\n}\n\n.border-t-transparent {\n  border-top-color: transparent;\n}\n\n.bg-\\[\\#E7F2FA\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(231 242 250 / var(--tw-bg-opacity));\n}\n\n.bg-\\[\\#f4b610\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(244 182 16 / var(--tw-bg-opacity));\n}\n\n.bg-accent-1 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(217 191 255 / var(--tw-bg-opacity));\n}\n\n.bg-accent-2 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(15 15 116 / var(--tw-bg-opacity));\n}\n\n.bg-blue-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(37 99 235 / var(--tw-bg-opacity));\n}\n\n.bg-gray-900 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(17 24 39 / var(--tw-bg-opacity));\n}\n\n.bg-green-200 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(187 247 208 / var(--tw-bg-opacity));\n}\n\n.bg-primary {\n  --tw-bg-opacity: 1;\n  background-color: rgb(17 17 58 / var(--tw-bg-opacity));\n}\n\n.bg-secondary {\n  --tw-bg-opacity: 1;\n  background-color: rgb(74 162 233 / var(--tw-bg-opacity));\n}\n\n.bg-secondary\\/10 {\n  background-color: rgb(74 162 233 / 0.1);\n}\n\n.bg-secondary\\/15 {\n  background-color: rgb(74 162 233 / 0.15);\n}\n\n.bg-secondary\\/50 {\n  background-color: rgb(74 162 233 / 0.5);\n}\n\n.bg-slate-50 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(248 250 252 / var(--tw-bg-opacity));\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-white\\/30 {\n  background-color: rgb(255 255 255 / 0.3);\n}\n\n.bg-white\\/50 {\n  background-color: rgb(255 255 255 / 0.5);\n}\n\n.bg-opacity-50 {\n  --tw-bg-opacity: 0.5;\n}\n\n.bg-\\[url\\(\\'\\/assets\\/img\\/sidebar-bg\\.jpg\\'\\)\\] {\n  background-image: url('/src/assets/img/sidebar-bg.jpg');\n}\n\n.bg-cover {\n  background-size: cover;\n}\n\n.bg-center {\n  background-position: center;\n}\n\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.object-cover {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.p-5 {\n  padding: 1.25rem;\n}\n\n.p-6 {\n  padding: 1.5rem;\n}\n\n.px-0 {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.px-2\\.5 {\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.py-1\\.5 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n.py-20 {\n  padding-top: 5rem;\n  padding-bottom: 5rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.py-6 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem;\n}\n\n.pb-1\\.5 {\n  padding-bottom: 0.375rem;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem;\n}\n\n.pb-16 {\n  padding-bottom: 4rem;\n}\n\n.pt-1 {\n  padding-top: 0.25rem;\n}\n\n.pt-3 {\n  padding-top: 0.75rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.pt-6 {\n  padding-top: 1.5rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-start {\n  text-align: start;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-5xl {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.lowercase {\n  text-transform: lowercase;\n}\n\n.leading-none {\n  line-height: 1;\n}\n\n.text-accent-2 {\n  --tw-text-opacity: 1;\n  color: rgb(15 15 116 / var(--tw-text-opacity));\n}\n\n.text-blue-600 {\n  --tw-text-opacity: 1;\n  color: rgb(37 99 235 / var(--tw-text-opacity));\n}\n\n.text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n}\n\n.text-gray-600 {\n  --tw-text-opacity: 1;\n  color: rgb(75 85 99 / var(--tw-text-opacity));\n}\n\n.text-gray-800 {\n  --tw-text-opacity: 1;\n  color: rgb(31 41 55 / var(--tw-text-opacity));\n}\n\n.text-primary {\n  --tw-text-opacity: 1;\n  color: rgb(17 17 58 / var(--tw-text-opacity));\n}\n\n.text-primary\\/40 {\n  color: rgb(17 17 58 / 0.4);\n}\n\n.text-secondary {\n  --tw-text-opacity: 1;\n  color: rgb(74 162 233 / var(--tw-text-opacity));\n}\n\n.text-secondary\\/50 {\n  color: rgb(74 162 233 / 0.5);\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.text-white\\/70 {\n  color: rgb(255 255 255 / 0.7);\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.opacity-25 {\n  opacity: 0.25;\n}\n\n.opacity-75 {\n  opacity: 0.75;\n}\n\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.shadow-sm {\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.blur {\n  --tw-blur: blur(8px);\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n\n.transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.delay-100 {\n  transition-delay: 100ms;\n}\n\n.duration-100 {\n  transition-duration: 100ms;\n}\n\n.duration-300 {\n  transition-duration: 300ms;\n}\n\n.duration-500 {\n  transition-duration: 500ms;\n}\n\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ease-out {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n\n.slider-navs .tns-nav-active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(74 162 233 / var(--tw-bg-opacity));\n}\n\n.moveable-control-box {\n  display: none !important;\n}\n\n/* Tab */\n\n.tab .active {\n  --tw-border-opacity: 1;\n  border-color: rgb(15 15 116 / var(--tw-border-opacity));\n  --tw-bg-opacity: 1;\n  background-color: rgb(15 15 116 / var(--tw-bg-opacity));\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.tab-content {\n  display: none;\n}\n\n.tab-content.active {\n  display: block;\n}\n\n.tab.reorder {\n  flex-direction: row;\n}\n\n.placeholder\\:text-transparent::-moz-placeholder {\n  color: transparent;\n}\n\n.placeholder\\:text-transparent::placeholder {\n  color: transparent;\n}\n\n.before\\:absolute::before {\n  content: var(--tw-content);\n  position: absolute;\n}\n\n.before\\:inset-0::before {\n  content: var(--tw-content);\n  inset: 0px;\n}\n\n.before\\:-bottom-\\[11px\\]::before {\n  content: var(--tw-content);\n  bottom: -11px;\n}\n\n.before\\:-bottom-\\[13px\\]::before {\n  content: var(--tw-content);\n  bottom: -13px;\n}\n\n.before\\:left-0::before {\n  content: var(--tw-content);\n  left: 0px;\n}\n\n.before\\:z-\\[1\\]::before {\n  content: var(--tw-content);\n  z-index: 1;\n}\n\n.before\\:h-\\[3px\\]::before {\n  content: var(--tw-content);\n  height: 3px;\n}\n\n.before\\:w-\\[calc\\(100\\%\\+\\.5rem\\)\\]::before {\n  content: var(--tw-content);\n  width: calc(100% + .5rem);\n}\n\n.before\\:bg-secondary::before {\n  content: var(--tw-content);\n  --tw-bg-opacity: 1;\n  background-color: rgb(74 162 233 / var(--tw-bg-opacity));\n}\n\n.after\\:absolute::after {\n  content: var(--tw-content);\n  position: absolute;\n}\n\n.after\\:inset-0::after {\n  content: var(--tw-content);\n  inset: 0px;\n}\n\n.after\\:h-full::after {\n  content: var(--tw-content);\n  height: 100%;\n}\n\n.after\\:w-full::after {\n  content: var(--tw-content);\n  width: 100%;\n}\n\n.after\\:content-\\[\\'\\'\\]::after {\n  --tw-content: '';\n  content: var(--tw-content);\n}\n\n.autofill\\:pb-2:-webkit-autofill {\n  padding-bottom: 0.5rem;\n}\n\n.autofill\\:pb-2:autofill {\n  padding-bottom: 0.5rem;\n}\n\n.autofill\\:pt-6:-webkit-autofill {\n  padding-top: 1.5rem;\n}\n\n.autofill\\:pt-6:autofill {\n  padding-top: 1.5rem;\n}\n\n.hover\\:border-\\[\\#5BE7CD\\]:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(91 231 205 / var(--tw-border-opacity));\n}\n\n.hover\\:border-\\[\\#F55F6E\\]:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(245 95 110 / var(--tw-border-opacity));\n}\n\n.hover\\:border-\\[\\#f4b610\\]:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(244 182 16 / var(--tw-border-opacity));\n}\n\n.hover\\:border-accent-2:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(15 15 116 / var(--tw-border-opacity));\n}\n\n.hover\\:border-blue-600:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(37 99 235 / var(--tw-border-opacity));\n}\n\n.hover\\:border-primary:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(17 17 58 / var(--tw-border-opacity));\n}\n\n.hover\\:bg-\\[\\#5BE7CD\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(91 231 205 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-\\[\\#F55F6E\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(245 95 110 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-\\[\\#f4b610\\]:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(244 182 16 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-accent-2:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(15 15 116 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-accent-2\\/10:hover {\n  background-color: rgb(15 15 116 / 0.1);\n}\n\n.hover\\:bg-gray-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-gray-300:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(209 213 219 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-primary:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(17 17 58 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-secondary:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(74 162 233 / var(--tw-bg-opacity));\n}\n\n.hover\\:bg-secondary\\/20:hover {\n  background-color: rgb(74 162 233 / 0.2);\n}\n\n.hover\\:bg-secondary\\/30:hover {\n  background-color: rgb(74 162 233 / 0.3);\n}\n\n.hover\\:text-black:hover {\n  --tw-text-opacity: 1;\n  color: rgb(0 0 0 / var(--tw-text-opacity));\n}\n\n.hover\\:text-blue-600:hover {\n  --tw-text-opacity: 1;\n  color: rgb(37 99 235 / var(--tw-text-opacity));\n}\n\n.hover\\:text-gray-600:hover {\n  --tw-text-opacity: 1;\n  color: rgb(75 85 99 / var(--tw-text-opacity));\n}\n\n.hover\\:text-primary:hover {\n  --tw-text-opacity: 1;\n  color: rgb(17 17 58 / var(--tw-text-opacity));\n}\n\n.hover\\:text-secondary:hover {\n  --tw-text-opacity: 1;\n  color: rgb(74 162 233 / var(--tw-text-opacity));\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.focus\\:border-blue-500:focus {\n  --tw-border-opacity: 1;\n  border-color: rgb(59 130 246 / var(--tw-border-opacity));\n}\n\n.focus\\:border-x-transparent:focus {\n  border-left-color: transparent;\n  border-right-color: transparent;\n}\n\n.focus\\:border-b-secondary:focus {\n  --tw-border-opacity: 1;\n  border-bottom-color: rgb(74 162 233 / var(--tw-border-opacity));\n}\n\n.focus\\:border-t-transparent:focus {\n  border-top-color: transparent;\n}\n\n.focus\\:bg-gray-100:focus {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity));\n}\n\n.focus\\:pb-2:focus {\n  padding-bottom: 0.5rem;\n}\n\n.focus\\:pt-6:focus {\n  padding-top: 1.5rem;\n}\n\n.focus\\:text-gray-600:focus {\n  --tw-text-opacity: 1;\n  color: rgb(75 85 99 / var(--tw-text-opacity));\n}\n\n.focus\\:text-secondary:focus {\n  --tw-text-opacity: 1;\n  color: rgb(74 162 233 / var(--tw-text-opacity));\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:ring:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-0:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-2:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-accent-2\\/20:focus {\n  --tw-ring-color: rgb(15 15 116 / 0.2);\n}\n\n.focus\\:ring-blue-500:focus {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));\n}\n\n.focus\\:ring-blue-500\\/20:focus {\n  --tw-ring-color: rgb(59 130 246 / 0.2);\n}\n\n.focus\\:ring-primary\\/20:focus {\n  --tw-ring-color: rgb(17 17 58 / 0.2);\n}\n\n.disabled\\:pointer-events-none:disabled {\n  pointer-events: none;\n}\n\n.disabled\\:text-gray-300:disabled {\n  --tw-text-opacity: 1;\n  color: rgb(209 213 219 / var(--tw-text-opacity));\n}\n\n.disabled\\:opacity-50:disabled {\n  opacity: 0.5;\n}\n\n.group:hover .group-hover\\:text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.group:hover .group-hover\\:ring {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.group:hover .group-hover\\:ring-secondary\\/20 {\n  --tw-ring-color: rgb(74 162 233 / 0.2);\n}\n\n.peer:focus ~ .peer-focus\\:-translate-y-3 {\n  --tw-translate-y: -0.75rem;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:focus ~ .peer-focus\\:scale-90 {\n  --tw-scale-x: .9;\n  --tw-scale-y: .9;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:focus ~ .peer-focus\\:text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n}\n\n.peer:disabled ~ .peer-disabled\\:pointer-events-none {\n  pointer-events: none;\n}\n\n.peer:disabled ~ .peer-disabled\\:opacity-50 {\n  opacity: 0.5;\n}\n\n.peer:not(:-moz-placeholder-shown) ~ .peer-\\[\\:not\\(\\:-moz-placeholder-shown\\)\\]\\:-translate-y-3 {\n  --tw-translate-y: -0.75rem;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:-translate-y-3 {\n  --tw-translate-y: -0.75rem;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:not(:-moz-placeholder-shown) ~ .peer-\\[\\:not\\(\\:-moz-placeholder-shown\\)\\]\\:scale-90 {\n  --tw-scale-x: .9;\n  --tw-scale-y: .9;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:scale-90 {\n  --tw-scale-x: .9;\n  --tw-scale-y: .9;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.peer:not(:-moz-placeholder-shown) ~ .peer-\\[\\:not\\(\\:-moz-placeholder-shown\\)\\]\\:text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n}\n\n.peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n}\n\n[data-hs-tab].active.hs-tab-active\\:border-secondary {\n  --tw-border-opacity: 1;\n  border-color: rgb(74 162 233 / var(--tw-border-opacity));\n}\n\n[data-hs-tab].active.hs-tab-active\\:text-secondary {\n  --tw-text-opacity: 1;\n  color: rgb(74 162 233 / var(--tw-text-opacity));\n}\n\n[data-hs-tab].active .hs-tab-active\\:border-secondary {\n  --tw-border-opacity: 1;\n  border-color: rgb(74 162 233 / var(--tw-border-opacity));\n}\n\n[data-hs-tab].active .hs-tab-active\\:text-secondary {\n  --tw-text-opacity: 1;\n  color: rgb(74 162 233 / var(--tw-text-opacity));\n}\n\n.open.hs-overlay-open\\:mt-7 {\n  margin-top: 1.75rem;\n}\n\n.open.hs-overlay-open\\:translate-x-0 {\n  --tw-translate-x: 0px;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.open.hs-overlay-open\\:opacity-100 {\n  opacity: 1;\n}\n\n.open.hs-overlay-open\\:duration-500 {\n  transition-duration: 500ms;\n}\n\n.open .hs-overlay-open\\:mt-7 {\n  margin-top: 1.75rem;\n}\n\n.open .hs-overlay-open\\:translate-x-0 {\n  --tw-translate-x: 0px;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n\n.open .hs-overlay-open\\:opacity-100 {\n  opacity: 1;\n}\n\n.open .hs-overlay-open\\:duration-500 {\n  transition-duration: 500ms;\n}\n\n.selected.hs-selected\\:block {\n  display: block;\n}\n\n.selected .hs-selected\\:block {\n  display: block;\n}\n\n.disabled.hs-select-disabled\\:pointer-events-none {\n  pointer-events: none;\n}\n\n.disabled.hs-select-disabled\\:opacity-50 {\n  opacity: 0.5;\n}\n\n.disabled .hs-select-disabled\\:pointer-events-none {\n  pointer-events: none;\n}\n\n.disabled .hs-select-disabled\\:opacity-50 {\n  opacity: 0.5;\n}\n\n@media (min-width: 640px) {\n  .sm\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .sm\\:w-full {\n    width: 100%;\n  }\n\n  .sm\\:max-w-xl {\n    max-width: 36rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:-bottom-16 {\n    bottom: -4rem;\n  }\n\n  .md\\:h-\\[200px\\] {\n    height: 200px;\n  }\n\n  .md\\:gap-6 {\n    gap: 1.5rem;\n  }\n\n  .md\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .md\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .md\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .md\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .md\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:left-auto {\n    left: auto;\n  }\n\n  .lg\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .lg\\:block {\n    display: block;\n  }\n\n  .lg\\:hidden {\n    display: none;\n  }\n\n  .lg\\:h-10 {\n    height: 2.5rem;\n  }\n\n  .lg\\:h-full {\n    height: 100%;\n  }\n\n  .lg\\:w-72 {\n    width: 18rem;\n  }\n\n  .lg\\:w-96 {\n    width: 24rem;\n  }\n\n  .lg\\:w-\\[calc\\(100\\%-290px\\)\\] {\n    width: calc(100% - 290px);\n  }\n\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n\n  .lg\\:flex-col {\n    flex-direction: column;\n  }\n\n  .lg\\:gap-4 {\n    gap: 1rem;\n  }\n\n  .lg\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {\n    --tw-space-x-reverse: 0;\n    margin-right: calc(2rem * var(--tw-space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));\n  }\n\n  .lg\\:rounded-s-\\[3rem\\] {\n    border-start-start-radius: 3rem;\n    border-end-start-radius: 3rem;\n  }\n\n  .lg\\:rounded-tr-none {\n    border-top-right-radius: 0px;\n  }\n\n  .lg\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .lg\\:p-12 {\n    padding: 3rem;\n  }\n\n  .lg\\:p-8 {\n    padding: 2rem;\n  }\n\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .lg\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .lg\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n\n  .conv-lab-bottom-bar {\n    position: absolute;\n    width: calc(100% - 3rem);\n    bottom: 0.5rem;\n    left: 2rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .xl\\:-left-10 {\n    left: -2.5rem;\n  }\n\n  .xl\\:-right-10 {\n    right: -2.5rem;\n  }\n\n  .xl\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .xl\\:h-12 {\n    height: 3rem;\n  }\n\n  .xl\\:h-7 {\n    height: 1.75rem;\n  }\n\n  .xl\\:w-12 {\n    width: 3rem;\n  }\n\n  .xl\\:w-56 {\n    width: 14rem;\n  }\n\n  .xl\\:w-7 {\n    width: 1.75rem;\n  }\n\n  .xl\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .xl\\:gap-10 {\n    gap: 2.5rem;\n  }\n\n  .xl\\:gap-20 {\n    gap: 5rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .\\32xl\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n\n  .\\32xl\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n\n  .\\32xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .\\32xl\\:gap-20 {\n    gap: 5rem;\n  }\n\n  .\\32xl\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .\\32xl\\:p-16 {\n    padding: 4rem;\n  }\n\n  .\\32xl\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .conv-lab-bottom-bar {\n    position: absolute;\n    width: calc(100% - 7rem);\n    bottom: 0.5rem;\n    left: 3.5rem;\n  }\n}\n\n:is(:where(.dark) .dark\\:border-gray-700) {\n  --tw-border-opacity: 1;\n  border-color: rgb(55 65 81 / var(--tw-border-opacity));\n}\n\n:is(:where(.dark) .dark\\:bg-blue-500) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(59 130 246 / var(--tw-bg-opacity));\n}\n\n:is(:where(.dark) .dark\\:bg-slate-900) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(15 23 42 / var(--tw-bg-opacity));\n}\n\n:is(:where(.dark) .dark\\:bg-opacity-80) {\n  --tw-bg-opacity: 0.8;\n}\n\n:is(:where(.dark) .dark\\:text-gray-200) {\n  --tw-text-opacity: 1;\n  color: rgb(229 231 235 / var(--tw-text-opacity));\n}\n\n:is(:where(.dark) .dark\\:text-gray-400) {\n  --tw-text-opacity: 1;\n  color: rgb(156 163 175 / var(--tw-text-opacity));\n}\n\n:is(:where(.dark) .dark\\:text-white) {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n:is(:where(.dark) .dark\\:hover\\:border-gray-700:hover) {\n  --tw-border-opacity: 1;\n  border-color: rgb(55 65 81 / var(--tw-border-opacity));\n}\n\n:is(:where(.dark) .dark\\:hover\\:bg-gray-700:hover) {\n  --tw-bg-opacity: 1;\n  background-color: rgb(55 65 81 / var(--tw-bg-opacity));\n}\n\n:is(:where(.dark) .dark\\:focus\\:outline-none:focus) {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n:is(:where(.dark) .dark\\:focus\\:ring-1:focus) {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n:is(:where(.dark) .dark\\:focus\\:ring-gray-600:focus) {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {\n  border-radius: 9999px;\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {\n  --tw-bg-opacity: 1;\n  background-color: rgb(209 213 219 / var(--tw-bg-opacity));\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-secondary\\/80::-webkit-scrollbar-thumb {\n  background-color: rgb(74 162 233 / 0.8);\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {\n  --tw-bg-opacity: 1;\n  background-color: rgb(243 244 246 / var(--tw-bg-opacity));\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-secondary\\/20::-webkit-scrollbar-track {\n  background-color: rgb(74 162 233 / 0.2);\n}\n\n.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n.\\[\\&\\:not\\(\\:-moz-placeholder-shown\\)\\]\\:pb-2:not(:-moz-placeholder-shown) {\n  padding-bottom: 0.5rem;\n}\n\n.\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pb-2:not(:placeholder-shown) {\n  padding-bottom: 0.5rem;\n}\n\n.\\[\\&\\:not\\(\\:-moz-placeholder-shown\\)\\]\\:pt-6:not(:-moz-placeholder-shown) {\n  padding-top: 1.5rem;\n}\n\n.\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pt-6:not(:placeholder-shown) {\n  padding-top: 1.5rem;\n}\n\n@media (min-height: 800px) {\n  .h-justify-around {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n  .h-mt-6 {\n    margin-top: 1.5rem;\n  }\n  .h-mt-10 {\n    margin-top: 2.5rem;\n  }\n  .h-py-8 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n  .h-gap-3 {\n    gap: 0.75rem;\n  }\n  .h-py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .h-max-h-\\[450px\\] {\n    max-height: 450px;\n  }\n  .h-max-h-\\[480px\\] {\n    max-height: 480px;\n  }\n}\n\n.search-icon {\n  cursor: pointer;\n  transition: width 2s ease;\n}\n\n.move-left {\n  right: calc(100% - 20px); /* Moves to left, adjust based on your layout */\n}\n\ndiv#date-pick-div > div > div > :first-child {\n  background-color: rgb(230, 239, 246);\n}\n\ndiv#date-pick-div > div > div > :last-child {\n  /* background-color: rgb(91 231 205 / var(--tw-border-opacity)); */\n  background-color: rgb(230, 239, 246) !important;\n}\n\ndiv#date-pick-div > div > div button:not(.text-gray-400){\n  color: black !important;\n}\n\n/* div#date-pick-div > div > div button.w-12.h-12 {\n  width: 2rem;\n  height: 2rem;\n} */\n\ndiv#date-pick-div > div > div button.text-indigo-500{\n  border-bottom: 1px solid indigo;\n}\n\ndiv#date-pick-div > div > div button.font-medium{\n  border: 1px solid indigo;\n}\n\ndiv.search-component select option {\n  background-color: rgb(230, 239, 246);\n  text-align: start;\n  border-bottom: 1px solid indigo;\n}\n\n.playback-scrollbar::-webkit-scrollbar {\n  width: 8px; /* Width of the vertical scrollbar */\n}\n.playback-scrollbar::-webkit-scrollbar-track {\n  background: rgba(74, 162, 233, 0.2); /* Track color */\n}\n.playback-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(74, 162, 233, 0.8); /* Thumb color */\n}\n\n/* Horizontal scrollbar */\n.playback-scrollbar::-webkit-scrollbar:horizontal {\n  height: 8px; /* Height of the horizontal scrollbar */\n}\n\n.min-w-min {\n  min-width: min-content;\n}\n\n.resize-none {\n  resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
